import { IMap } from "@/Common/Models/IMap";
import { DropdownItem } from "@/Common/Models/UI/Inputs/DropdownItem";
import { BaseSearchAutocompleteCustom } from "./BaseSearchAutocompleteCustom";

interface ISimpleDisplayModel<TData> {
    Id: number | string;
    DisplayText: string;
    Data?: TData;
    CssClass?: string;
}

class SimpleDisplayModel<TData> extends DropdownItem<ISimpleDisplayModel<TData>> {
    public constructor(fields?: DropdownItem<ISimpleDisplayModel<TData>>) {
        super();
        Object.assign(this, fields);
    }

    public static fromDictionary(obj?: IMap<string | { Label: string }>, sortAlphabetically: boolean = true): DropdownItem<ISimpleDisplayModel<null>>[] {
        const dropDownItems = Object
            .keys(obj ?? {})
            .map(key => new DropdownItem<ISimpleDisplayModel<null>>({
                Item: {
                    Id: key,
                    DisplayText: typeof obj[key] === "string"
                        ? obj[key]
                        : obj[key]["Label"]
                }
            }));

        return sortAlphabetically
            ? dropDownItems.sortByProperty(x => x.Item.DisplayText.toLowerCase())
            : dropDownItems;
    }
}

class SimpleSearchComplete<TData> extends BaseSearchAutocompleteCustom<ISimpleDisplayModel<TData>> {
    protected defaultSearchStrategy = null;

    protected renderLabel(model: ISimpleDisplayModel<TData>): string {
        return model.DisplayText;
    }

    protected searchStrategyRenderItem(model: ISimpleDisplayModel<TData>, cssClass?: string): React.ReactNode {
        return <div className={cssClass}><span>{this.renderLabel(model)}</span></div>;
    }

    protected getItemId(model: ISimpleDisplayModel<TData>): React.ReactText {
        return model.Id;
    }
}

export { ISimpleDisplayModel, SimpleDisplayModel, SimpleSearchComplete };
